import { readMachineStatus } from 'tf-pulse-shared';
import { Machine as GeneratedMachine } from '../../gql/generated';
import { MachineStatus } from '../../types/machines/machine.types';

/**
 * What the list already knows about a machine. The list passes it in the
 * navigation state, so the detail page's app bar names the machine and takes
 * its status colour before the machine query returns.
 */
export interface MachineDetailPreview {
  name: string;
  status: MachineStatus;
}

export function toMachineDetailPreview(
  machine: Pick<GeneratedMachine, 'displayName' | 'machineId' | 'state'>
): MachineDetailPreview {
  return {
    name: machine.displayName || machine.machineId,
    status: readMachineStatus(machine.state).status,
  };
}

/** The preview from a navigation state, or null when the page opened without one. */
export function readMachineDetailPreview(
  state: unknown
): MachineDetailPreview | null {
  if (typeof state !== 'object' || state === null) return null;

  const { preview } = state as { preview?: Partial<MachineDetailPreview> };
  return typeof preview?.name === 'string' && typeof preview.status === 'string'
    ? { name: preview.name, status: preview.status }
    : null;
}
